import React, { useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";

//Redux
import { useSelector } from "react-redux"; // useDispatch

//API
import ItemService from "../../../../../services/supplier_appCommonService";

//Components
import Layout from "../../../../../Layout/Layout";
import { InputField } from "../../../../../Components/formElements/InputField";

import Constants from "../../../../../common/SupplierConstants";
import ApproveRemarksModal from "../../../../../Components/Modal/supplier_app/ApproveRemarksModal";
import SuccessModal from "../../../../../Components/Modal/supplier_app/SuccessModal";

const BillingDetail = () => {
  localStorage.setItem("menu", "Purchasing");
  localStorage.setItem("submenu", "");

  //dummy invoiceNumber
  const invoiceNumber = 12345;

  let workflow = useSelector(
    (state) => state?.purchasing?.purchase_order?.workflowPO
  ); // workflowPO from Store

  // invoice columns
  const invoiceDataColumns = [
    {
      name: "Image",
      selector: (row) => row.Image,
      cell: (row) => (
        <>
          <img
            src="assets/img/profile-img.png"
            alt="Profile"
            class="rounded-circle profileImageCss"
            style={{ width: "40px" }}
          ></img>
        </>
      ),
      sortable: true,
      width: "100px",
    },
    // {
    //   name: "PO Item Nr",
    //   selector: (row) => row.purchasingDocumentItemNr,
    //   sortable: true,
    //   width: "120px",
    // },
    // {
    //   name: "GRN Item Nr",
    //   selector: (row) => row.grnItemNr,
    //   sortable: true,
    //   width: "130px",
    // },
    {
      name: "Material",
      selector: (row) => row.material,
      cell: (row) => (
        <>
          <p>{row.material}</p>
        </>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "QTY",
      cell: (row) => (
        <>
          {/* <span className="bg-table-status bg-table-info-status">{"New"}</span> */}
          <p>{row.qty}</p>
        </>
      ),
      width: "150px",
    },
    {
      name: "UnitPrice",
      selector: (row) => row.unitPrice,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row.unitPrice} </p>
            {/* <p className="m-0 p-0">{row.materialDescription} </p> */}
          </div>
        </>
      ),
      width: "180px",
      sortable: true,
    },
    // {
    //   name: "Purchase Qty",
    //   selector: (row) => row.purchaseQuantity,
    //   cell: (row) => <>{row.purchaseQuantity}</>,
    //   sortable: true,
    //   width: "150px",
    // },
    {
      name: "Gross Amt",
      selector: (row) => row.grossAmt,
      cell: (row) => <>{row.grossAmt}</>,
      sortable: true,
      width: "150px",
    },
    {
      name: "Tax%",
      cell: (row) => <>{row.tax}</>,
      sortable: true,
      width: "160px",
    },
    {
      name: "Tax Amt",
      cell: (row) => <>{row.taxAMt}</>,
      sortable: true,
      width: "180px",
    },
    {
      name: "Net Amt",
      selector: (row) => <>{row.netAmt}</>,
      sortable: true,
      width: "120px",
    },
    // {
    //   name: "Unit Price",
    //   // selector: (row) => row.orderPriceUnit,
    //   cell: (row) => (
    //     <span className="numberFormate">
    //       {currencyFormat(Number(row.orderPriceUnit).toFixed(2))}
    //     </span>
    //   ),

    //   sortable: true,
    //   width: "120px",
    // },
    // {
    //   name: "Item Value",
    //   selector: (row) => row.totalPrice,
    //   cell: (row) => <>{row.totalPrice}</>,
    //   sortable: true,
    //   width: "180px",
    // },
    // {
    //   name: "Total Value",
    //   selector: (row) => row.netValue,
    //   cell: (row) => <>{row.netValue}</>,
    //   sortable: true,
    //   width: "180px",
    // },
    // {
    //   name: "Currency",
    //   selector: (row) => row.currencyCode,
    //   sortable: true,
    //   width: "120px",
    // },
    // {
    //   name: "Delivery Date",
    //   selector: (row) => row.deliveryDate,
    //   sortable: true,
    //   width: "140px",
    // },
    // {
    //   name: "Tax Amount",
    //   selector: (row) => row.taxAmount,
    //   sortable: true,
    //   width: "140px",
    // },
    // {
    //   name: "Tax Code",
    //   selector: (row) => row.taxCode,
    //   sortable: true,
    //   width: "130px",
    // },
    // {
    //   name: "Tax Desc",
    //   selector: (row) => row.taxIdDesc,
    //   sortable: true,
    //   width: "200px",
    // },
    // {
    //   name: "PReq Nr",
    //   selector: (row) => row.purchaseReqNr,
    //   sortable: true,
    //   width: "200px",
    // },
    // {
    //   name: "PReq Item Nr ",
    //   selector: (row) => row.purchaseReqitemNr,
    //   sortable: true,
    //   width: "200px",
    // },
    // {
    //   name: "ExcessTolerance",
    //   selector: (row) => row.excessTolerance,
    //   sortable: true,
    //   width: "200px",
    // },
    // {
    //   name: "ShortageTolerance",
    //   selector: (row) => row.shortageTolerance,
    //   sortable: true,
    //   width: "200px",
    // },
  ];

  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);

  const [getDisabledStatus] = useState(true);

  const [modalShow, setModalShow] = useState(false);
  const [getAction, setAction] = useState("");

  /* dummy data */
  const data = [
    {
      id: 1,
      material:
        "canon Big cakes self striping Yarn - 603 yd/551 m/10 50z/300g Each",
      qty: "5",
      unitPrice: "2,347.78",
      grossAmt: "11,3478.78",
      tax: "0.00",
      taxAMt: "0",
      netAmt: "11.347.78",
    },
    {
      id: 2,
      material:
        "canon Big cakes self striping Yarn - 603 yd/551 m/10 50z/300g Each",
      qty: "5",
      unitPrice: "2,347.78",
      grossAmt: "11,3478.78",
      tax: "0.00",
      taxAMt: "0",
      netAmt: "11.347.78",
    },
  ];
  /* success modal */
  const successModalData = {
    title: "Message",
    successMsg: "",
  };
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getsucceModalData, setsucceModalData] = useState(successModalData);
  const [getNextNavigate, setNextNavigate] = useState("");
  const onSuccessmodel = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const [formInputs, setFormInputs] = useState({
    transactionActivity: "INV",
    subTransactionActivity: "GRN",
    vendorCode: "",
    purchasingDocumentNr: "",
    purchasingDocumentDate: "",
    purchasingDocumentValue: "",
    currency: "",
    currencyCode: "",
    paymentTerms: "",
    totalInvoiceAmount: "",
    sumOfCurrentAmt: "",
    notes: "",
    weighSlipQty: "",
    itemClass: "",
    vendorInvoiceNo: "",
    vendorInvoiceDate: "",
    vendorInvoiceCurrency: "",
    vendorBasicValue: "",
    vendorFreightValue: "",
    vendorTaxValue: "",
    vendorOtherChargesValue: "",
    vendorTotalInvoiceValue: "",
    invoicedValue: "",
    generatedBy: "",
    createdBy: "",
  });

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    // console.log("onInputChange => formInputs", formInputs);
  };

  // Workflow
  const navigateToWorkflow = () => {
    window.history.back();
  };
  const showApproveModal = async (name) => {
    setModalShow(true);
    setAction(name);
  };
  const workflowApproveReject = async (remarks) => {
    let obj = {};
    let bodyObj = workflow?.workflow_record?.workflowActionAPI?.Body;

    obj._id = workflow?.workflow_record?._id;
    obj.businessComponentId = workflow?.workflow_record?.businessComponentId;
    obj.eventId = workflow?.workflow_record?.eventId;
    obj.businessComponentInstanceId =
      workflow?.workflow_record?.businessComponentInstanceId;
    obj.stepId = workflow?.workflow_record?.stepId;
    obj.action = getAction;
    obj.remark = remarks;
    obj.editContextData = workflow?.workflow_record?.editContextData;
    obj.editForm = workflow?.workflow_record?.editForm;
    obj.data = {};
    let newObj = { ...bodyObj, ...obj };

    //Approve
    await ItemService.workflowApproveReject(newObj).then((item) => {
      // console.log(">> item!", item);
      if (item?.status === 200) {
        successModalData.successMsg =
          getAction === "Approve"
            ? "Approved Successfully !!"
            : "Rejected Successfully !!";
        setsucceModalData(successModalData);
        setNextNavigate(Constants.INBOX);
        onSuccessmodel();
      } else {
        console.log(">> Error: Loading workflowApproveReject");
      }
    });
  };
  const handleValueChange = (remarks) => {
    workflowApproveReject(remarks);
  };
  const hideModal = () => {
    setModalShow(false);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />

      <Row className="justify-center subContent">
        <Col xs={12} md={12} lg={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              Billing Details :{" "}
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {invoiceNumber}
              </span>
              <span>
                {formInputs?.invoiceStatusHeader === "Invoice Created" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {formInputs?.invoiceStatusHeader}
                  </span>
                ) : formInputs?.invoiceStatusHeader ===
                  "Pending for Approval" ? (
                  <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                    {formInputs?.invoiceStatusHeader}
                  </span>
                ) : formInputs?.invoiceStatusHeader === "Invoice Approved" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {formInputs?.invoiceStatusHeader}
                  </span>
                ) : (
                  formInputs?.invoiceStatusHeader
                )}
              </span>
            </h2>
            <p className="subText">Billing Details</p>
            <hr />

            <Row className="mb-4">
              <Col xs={12} md={4} lg={4} className="text-left">
                <button
                  className="btnBack"
                  onClick={() => navigateToWorkflow()}
                >
                  <i className="bi bi-arrow-return-left"></i> Go Back
                </button>
              </Col>
              <Col xs={12} md={8} lg={8} className="text-right">
                {workflow?.workflow_record?.decision?.length > 0 &&
                  workflow?.workflow_record?.decision?.map((item, index) => (
                    <button
                      className={
                        item === "Approve" || item === "Submit"
                          ? "btnCommon btn-approve"
                          : "btnCommon btn-danger"
                      }
                      onClick={() => showApproveModal(item)}
                      key={index}
                    >
                      <i
                        className={
                          item === "Approve" || item === "Submit"
                            ? "bi bi-check2-circle"
                            : "bi bi-x-circle"
                        }
                      ></i>{" "}
                      {item}
                    </button>
                  ))}
              </Col>
            </Row>

            <>
              {/* Invoice header */}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">GH</span>
                      </Col>
                      <Col xs={12} md={9} lg={9}>
                        <span className="headerTitle">Billing Details</span>
                        <span className="subHeaderTitle">Billing Details</span>
                      </Col>
                    </Row>
                  </h2>
                  <div
                    className={`accordion-collapse collapse show ${
                      isCardVisible ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Bill"
                            name="bill"
                            placeholder=""
                            // value={currentDate}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Delivery"
                            name="delivery"
                            placeholder=""
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding d-flex-column"
                        >
                          <InputField
                            className="inputBox"
                            label="Net amt"
                            name="netamt"
                            placeholder=""
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding d-flex-column"
                        >
                          <InputField
                            className="inputBox"
                            label="Bill Date"
                            name="billDate"
                            type="date"
                            placeholder=""
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Delivery Date"
                            name="deliveryDate"
                            type="date"
                            placeholder=""
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding d-flex-column"
                        >
                          <InputField
                            className="inputBox"
                            label="Customer Ref"
                            name="customerRef"
                            placeholder=""
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding d-flex-column"
                        >
                          <InputField
                            className="inputBox"
                            label="Gross amt"
                            name="grossAmt"
                            placeholder=""
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding d-flex-column"
                        >
                          <InputField
                            className="inputBox"
                            label="Tax amt"
                            name="taxAmt"
                            placeholder=""
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding d-flex-column"
                        >
                          <InputField
                            className="inputBox"
                            label="PO"
                            name="po"
                            placeholder=""
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding d-flex-column"
                        >
                          <InputField
                            className="inputBox"
                            label="SO"
                            name="so"
                            placeholder=""
                            disabled={getDisabledStatus}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
              {/* invoice service itme details table*/}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible2
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility2}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">PI</span>
                      </Col>
                      <Col xs={12} md={8} lg={8}>
                        <span className="headerTitle">Item Details</span>
                        <span className="subHeaderTitle">Item Details</span>
                      </Col>
                    </Row>
                  </h2>
                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${
                      isCardVisible2 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            columns={invoiceDataColumns}
                            data={data}
                            // progressPending={loading}
                            paginationRowsPerPageOptions={
                              Constants.ROW_PER_PAGE
                            }
                            pagination
                            // paginationServer
                            // paginationTotalRows={totalRows}
                            // onChangeRowsPerPage={handlePerRowsChange}
                            // onChangePage={handlePageChange}
                            selectableRows
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            </>
          </div>
        </Col>
      </Row>

      {/* Modal Workflow */}
      <ApproveRemarksModal
        show={modalShow}
        onHide={() => hideModal()}
        onvaluechange={handleValueChange}
      />

      {/* Success Modal Workflow */}
      <SuccessModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        successmodaldata={getsucceModalData}
        nextnavigate={getNextNavigate}
      />
    </main>
  );
};

export default BillingDetail;
